import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogAPI } from '../../services/api';
import { blogPosts as mockBlogPosts } from '../../data/mock';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const BlogSection = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBlogPosts = async () => {
      try {
        const data = await blogAPI.getAll();
        setBlogPosts(data.length > 0 ? data : mockBlogPosts);
      } catch (error) {
        console.error('Error loading blog posts:', error);
        setBlogPosts(mockBlogPosts);
      } finally {
        setLoading(false);
      }
    };
    loadBlogPosts();
  }, []);

  if (loading) {
    return <div className="py-20 text-center text-gray-500">Loading blog posts...</div>;
  }
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <h2 className="text-3xl md:text-4xl font-light text-gray-900" style={{ fontFamily: 'Georgia, serif' }}>
            Blog posts
          </h2>
          <Link
            to="/news"
            className="text-sm text-gray-600 hover:text-black transition-colors underline"
          >
            View all
          </Link>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {blogPosts.slice(0, 2).map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>

        {/* Pagination Dots */}
        <div className="flex items-center justify-center mt-10 space-x-4">
          <button className="p-2 text-gray-400 hover:text-black transition-colors">
            <ChevronLeft className="w-5 h-5" />
          </button>
          <span className="text-sm text-gray-500">1 / 2</span>
          <button className="p-2 text-gray-400 hover:text-black transition-colors">
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>

        {/* View All Button */}
        <div className="text-center mt-8">
          <Link
            to="/news"
            className="inline-block px-10 py-3 bg-black text-white text-sm tracking-wide hover:bg-gray-800 transition-colors rounded-md"
          >
            View all
          </Link>
        </div>
      </div>
    </section>
  );
};

const BlogCard = ({ post }) => {
  return (
    <Link to={`/news/${post.slug}`} className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
      {/* Image */}
      {post.image && (
        <div className="aspect-video overflow-hidden">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      )}

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-medium text-gray-900 group-hover:underline line-clamp-2 mb-3" style={{ fontFamily: 'Georgia, serif' }}>
          {post.title}
        </h3>
        <p className="text-xs text-gray-400 uppercase tracking-wider mb-3">
          {post.date}
        </p>
        <p className="text-sm text-gray-600 line-clamp-3">
          {post.excerpt}
        </p>
      </div>
    </Link>
  );
};

export default BlogSection;
